// 最近更新 (D-222): one list of what changed for teachers, read by the public /updates page, the homepage block
// and the 功能更新 tab of the teacher's notices. entries.json holds the facts (id, day, theme, picture, where it
// is in the app); i18n/<locale>.json holds the words, keyed by id. docs/UPDATES-SOP.md says how a release adds one.
import entries from "./entries.json";

export type UpdateTheme = "homework" | "student-links" | "pets" | "classroom" | "contact" | "rewards" | "tools" | "account";
export type UpdateEntry = {
  id: string;
  /** The day it went live for everyone (Taipei calendar), YYYY-MM-DD. Entries dated after today stay hidden. */
  date: string;
  theme: UpdateTheme;
  /** Which plan can use it: free = every teacher, plus = 標準版 and above. */
  plan: "free" | "plus";
  /** Something a teacher asked for in a ticket or message. */
  fromTeachers?: boolean;
  /** One of the few simple, everyday wins the page and the homepage lead with (most teachers, free plan). */
  featured?: boolean;
  /** A big one: the teacher's dashboard shows it once as a small card (never while projecting). */
  highlight?: boolean;
  /** The picture under web/public/assets/changelog/, without extension (.webp), or null. */
  image: string | null;
  /** Where it lives in the teacher's class, as a workspace route ("homework", "store?view=requests", …), or null. */
  route: string | null;
  /** A public page instead of a class route: a free tool (/tools/…) or the help center (/help…, D-273). */
  toolPath?: string | null;
};
export type UpdateText = { title: string; summary: string; steps: string[]; alt?: string };
export type UpdatePageCopy = { title: string; description: string };

export const UPDATE_ENTRIES: readonly UpdateEntry[] = (entries.entries as UpdateEntry[]).slice().sort((a, b) => b.date.localeCompare(a.date) || a.id.localeCompare(b.id));

/**
 * Updates dated before this day are shown in 功能更新 but never count as unread: the panel started with a month
 * of them (D-222), and a bell with 16 on it the first morning would be noise, not news.
 */
export const UPDATES_COUNTED_FROM = "2026-10-30";

/** The Taipei calendar day of `now`, so an entry dated today shows from midnight in Taiwan. */
export const taipeiDay = (now: Date) => new Date(now.getTime() + 8 * 3_600_000).toISOString().slice(0, 10);

/** Entries already live on `now`, newest first; `days` keeps only the recent ones (for notices). */
export function publishedUpdates(now: Date, days?: number): UpdateEntry[] {
  const today = taipeiDay(now);
  const from = days === undefined ? "" : taipeiDay(new Date(now.getTime() - days * 86_400_000));
  return UPDATE_ENTRIES.filter((entry) => entry.date <= today && entry.date >= from);
}
